import { useEffect, useState } from 'react';

/** Mirrors the `fit` Tailwind variant: the dashboard fills the viewport without page scroll. */
export const FIT_LAYOUT_MEDIA_QUERY = '(min-width: 1101px) and (min-height: 600px)';

function matches(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false;
}

export function useMediaQuery(query: string): boolean {
  const [isMatch, setIsMatch] = useState(() => matches(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return;
    }
    const mediaQuery = window.matchMedia(query);
    const update = () => setIsMatch(mediaQuery.matches);
    update();
    mediaQuery.addEventListener('change', update);
    return () => mediaQuery.removeEventListener('change', update);
  }, [query]);

  return isMatch;
}
